import { isMobile, setIsMobile } from '@manychat/manyui'

export const initIsMobile = () => {
  document.body.classList.add(isMobile ? 'mobile' : 'no-touch')
  setIsMobile(isMobile)
}
